/* eslint-disable @typescript-eslint/no-explicit-any */
import { Widget } from '@typeform/embed-react';
import React from 'react';
import type { BoxProps } from 'rebass/styled-components';

import { withErrorBoundary } from '../../components';

export interface EmbeddedContentModuleProps extends BoxProps {
  id: string;
  ID: any;
  embedType: string;
  title: string;
  name: string;
}

const EmbeddedContentModule = React.forwardRef<HTMLDivElement, EmbeddedContentModuleProps>(({ ID, embedType }) => {
  if (embedType === 'Typeform') {
    // Extract the typeform ID from the URL, handling both simple URLs and URLs with hash fragments
    const urlString = typeof ID === 'string' ? ID : ID.ID;

    // Split URL to separate base URL and hash fragment
    const [urlWithoutHash, hashFragment] = urlString?.split('#') || [];

    // Extract the form ID (last part after the last slash)
    const typeformId = urlWithoutHash?.split('/').pop();

    // Extract tracking parameters from hash fragment
    let hiddenParams = {};
    if (hashFragment) {
      hiddenParams = Object.fromEntries(new URLSearchParams(hashFragment));
    }

    return (
      <Widget
        id={typeformId}
        style={{ width: '100%' }}
        className="my-form md:-mb-[35px]"
        autoResize={true}
        hidden={hiddenParams}
        noScrollbars={true}
        hideHeaders
        hideFooter
        inlineOnMobile={true}
      />
    );
  }

  return null;
});
EmbeddedContentModule.displayName = 'EmbeddedContentModule';

export default withErrorBoundary(EmbeddedContentModule, { componentName: 'EmbeddedContentModule' });
